module.exports = __webpack_public_path__ + "images/emoji/dragon_face.9082c2ce6ed6ca2f57da.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dragon_face.png
// module id = tLKU
// module chunks = 13